import { INodeTemplate } from '@/types/node';
import { WidgetSettings } from '@/widget-editor/components';
import { Settings } from './edit';
import { Render as WidgetRender } from './render';
import {
  withWidgetDisplay,
  withWidgetSettings,
} from '@/widget-editor/utilities';

const template: INodeTemplate = {
  version: 1,
  icon: 'smart_button',
  name: 'Special Button',
  type: 'widget-actionbutton',
  tag: 'widgets',
  content: {
    widgetName: 'Special Button',
    label: '',
    description: '',
    call: 'videochat',
  },
  override: {
    root: {},
    button: {},
    image: {},
  },
  supports: {
    contexts: ['room'],
    appender: true,
  },
  //   depricated: [
  //     {
  //       migrate({ link, ...content }) {
  //         const { targeturl, ...otherParams } = link;
  //         return {
  //           ...content,
  //           link: { ...otherParams, targetUrl: targeturl },
  //         };
  //       },
  //     },
  //   ],
};

const Render = withWidgetDisplay(WidgetRender);

const Edit = withWidgetSettings(WidgetSettings)(Settings);

export { template, Edit, Render };
